// Strong, low-false-positive signals that the client is an automated agent
// (headless browser / automation framework) rather than a human.
export const hasBotCharacteristics = () => {
    try {
        const nav = window.navigator || {};

        // Explicit automation flag set by Selenium / Puppeteer / Playwright.
        if (nav.webdriver === true) return true;

        // Globals injected by common automation / headless frameworks.
        const automationGlobals = [
            '_phantom', '__nightmare', 'callPhantom', '__phantomas',
            'domAutomation', 'domAutomationController',
            '__webdriver_evaluate', '__driver_evaluate',
            '__selenium_evaluate', '__selenium_unwrapped', '__fxdriver_evaluate'
        ];
        if (automationGlobals.some((key) => key in window)) return true;
        if (document.documentElement.getAttribute('webdriver') !== null) return true;

        // A real browser always exposes at least one preferred language and
        // a non-zero window / screen size.
        if (nav.languages && nav.languages.length === 0) return true;
        if (window.outerWidth === 0 && window.outerHeight === 0) return true;
        if (window.screen && window.screen.width === 0 && window.screen.height === 0) return true;

        return false;
    } catch {
        // Never penalise a visit if detection itself fails.
        return false;
    }
};
